module.exports = __webpack_public_path__ + "img/upPriceArrow.4832827c.svg";